import moment from 'moment';
import fields from "./fields.utils.js";

const schema_gap =  {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    //Vehicle
    "vrm": {
        type: 'vehicle-lookup',
        value: '',
        required: true,

        placeholder: 'Registration Number'
    },
    "make": {
        label: 'make',
        type: 'select',
        value: '',
        options: [],

        placeholder: 'Make',
        required: true
    },
    "model": {
        label: 'model',
        type: 'text',

        placeholder: 'Model',
        value: ''
    },
    "year": {
        label: 'Year',
        type: 'number',
        required: true,
        value: '',

        placeholder: 'Year'
    },
    "body_type": {
        label: 'Type',
        type: 'select',
        value: '',
        options: [],

        placeholder: 'Type',
        required: true
    },
    "value": {
        label: 'Vehicle Value',
        type: 'number',
        value: null,
        required: true,

        placeholder: 'Vehicle Value'
    },
    "purchase_date": {
        label: 'Purchase Date',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Purchase Date'
    },
    //Driver
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,

    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
//policy
    "cover_date": {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format("DD/MM/YYYY"),
        required: true,

        placeholder: 'Cover Date'
    },
    "employment_status": {
        type: 'select',
        label: `employment status`,
        value: '',
        options: [],
        required: true
    },
    ...fields.marketing,
    ...fields.cross_selling
};
export default schema_gap;
